<template>
  <ppt-slide-viewer module-code="rt_jm2" />
</template>

<script>
import PptSlideViewer from "@/components/PptSlideViewer.vue";

export default {
  name: "RtJm2",
  components: { PptSlideViewer }
};
</script>
